import React, { useEffect, useState } from 'react';
import useResponsive from '../utils/useResponsive';
import { formatearMoneda } from '../utils/formatMoney';
import FiltroUsuarios from './FiltroUsuarios';
import { useFiltroUsuarios } from '../filtroUsuarios';
import { getUsuarioActual } from '../apiAuth';

const API = '/api';
const money = (v) => v ? `$${formatearMoneda(Math.round(Number(v) || 0))}` : '—';

const TABS = [
  { id: 'todas', label: 'Todas las Notificaciones' },
  { id: 'proximo_firmar', label: 'Próximos a Firmar' },
  { id: 'vigencia', label: 'Alerta Fin Vigencia Crédito' },
];

const sh = {
  toolbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginBottom: 16 },
  liveBadge: { display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11.5, fontWeight: 'bold', color: '#16794f', backgroundColor: '#e7f6ee', border: '1px solid #b9e6cc', borderRadius: 999, padding: '5px 12px' },
  tableScroll: { overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 },
  table: { width: '100%', borderCollapse: 'collapse', fontVariantNumeric: 'tabular-nums' },
  th: { textAlign: 'left', fontSize: 10.5, fontWeight: 'bold', color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.3, backgroundColor: '#f9fafb', padding: '6px 10px', borderBottom: '1px solid #e5e7eb' },
  td: { padding: '5px 10px', borderBottom: '1px solid #e5e7eb', fontSize: 12.5 },
  num: { textAlign: 'right' },
  empty: { padding: 24, textAlign: 'center', color: '#6b7280', fontSize: 13 },
  pill: (bg, color) => ({ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, fontWeight: 600, borderRadius: 999, padding: '2px 9px', backgroundColor: bg, color, whiteSpace: 'nowrap' }),
  btnLeida: { border: '1px solid #1a3a6e', backgroundColor: 'white', color: '#1a3a6e', fontSize: 11.5, fontWeight: 'bold', borderRadius: 6, padding: '5px 10px', cursor: 'pointer', whiteSpace: 'nowrap' },
};

const PILL_TIPO = {
  proximo_firmar: { label: 'Próximo a Firmar', bg: '#fff1e6', color: '#c2740a' },
  vigencia: { label: 'Fin Vigencia', bg: '#fde8e8', color: '#dc2626' },
};

const diasStyle = (tipo, dias) => {
  const umbralUrgente = tipo === 'proximo_firmar' ? 1 : 7;
  if (dias <= umbralUrgente) return { backgroundColor: '#fde8e8' };
  return { backgroundColor: '#fff4e0' };
};
const diasColor = (tipo, dias) => {
  const umbralUrgente = tipo === 'proximo_firmar' ? 1 : 7;
  return dias <= umbralUrgente ? '#dc2626' : '#c2740a';
};

const SeguimientoNotificacionesHome = ({ onVolver, onVerHipotecas, onVerReportes, onVerHistorico }) => {
  const { isMobile } = useResponsive();
  const [tab, setTab] = useState('todas');
  const [proximosFirmar, setProximosFirmar] = useState(null);
  const [vigencia, setVigencia] = useState(null);
  const [error, setError] = useState('');
  const usuarioActual = getUsuarioActual();
  const filtroUsuariosKey = useFiltroUsuarios().join(',');
  // Marcar como leída cambia lo que ve el dueño: el Administrador Plus solo lo hace en lo propio.
  const puedeMarcar = (f) => usuarioActual?.rol !== 'administrador_plus' || f.usuario_id === usuarioActual.id;

  const cargar = () => {
    fetch(`${API}/seguimiento-clientes/notificaciones`)
      .then(r => r.json())
      .then(d => {
        if (d.error) { setError(d.error); return; }
        setProximosFirmar(d.proximos_firmar);
        setVigencia(d.vigencia);
      })
      .catch(() => setError('No se pudieron cargar las notificaciones'));
  };

  // Se recarga también al cambiar el filtro de usuarios del Administrador Plus.
  useEffect(() => { cargar(); }, [filtroUsuariosKey]); // eslint-disable-line react-hooks/exhaustive-deps

  const marcarLeida = async (id, tipo) => {
    const r = await fetch(`${API}/seguimiento-bancos/${id}/notificacion-leida`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tipo }),
    });
    if (!r.ok) { setError('No se pudo marcar como leída'); return; }
    if (tipo === 'proximo_firmar') setProximosFirmar(prev => prev.filter(f => f.id !== id));
    else setVigencia(prev => prev.filter(f => f.id !== id));
  };

  const st = {
    container: { padding: isMobile ? 12 : 24, maxWidth: 1500, margin: '0 auto' },
    frame: { backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
    frameHeader: {
      backgroundColor: '#1a3a6e', color: 'white', padding: isMobile ? '14px 16px' : '16px 22px',
      display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap',
      position: 'sticky', top: 'var(--app-header-h, 120px)', zIndex: 31,
      borderRadius: '12px 12px 0 0',
    },
    backBtn: { background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.28)', color: 'white', fontSize: 12.5, fontWeight: 'bold', borderRadius: 7, padding: '7px 12px', cursor: 'pointer' },
    title: { margin: 0, fontSize: 17, fontWeight: 'bold' },
    tabs: {
      display: 'flex', gap: 4, borderBottom: '1px solid #e5e7eb', padding: '0 14px', overflowX: 'auto',
      backgroundColor: 'white', position: 'sticky', top: 'calc(var(--app-header-h, 120px) + 56px)', zIndex: 30,
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    },
    panel: { padding: isMobile ? 14 : '20px 22px 26px' },
  };
  const tabStyle = (active) => ({
    appearance: 'none', border: 'none', background: 'none', fontFamily: 'inherit',
    fontSize: 13, fontWeight: 600, color: active ? '#1a3a6e' : '#6b7280',
    padding: '14px 16px 12px', cursor: 'pointer', whiteSpace: 'nowrap',
    borderBottom: active ? '2.5px solid #f97316' : '2.5px solid transparent',
  });

  const cargando = proximosFirmar === null || vigencia === null;
  const todas = cargando ? null : [
    ...proximosFirmar.map(f => ({ ...f, tipo: 'proximo_firmar' })),
    ...vigencia.map(f => ({ ...f, tipo: 'vigencia' })),
  ].sort((a, b) => a.dias_restantes - b.dias_restantes);

  const filas = tab === 'todas' ? todas : (tab === 'proximo_firmar' ? proximosFirmar?.map(f => ({ ...f, tipo: 'proximo_firmar' })) : vigencia?.map(f => ({ ...f, tipo: 'vigencia' })));
  const mostrarTipoPill = tab === 'todas';
  const mostrarNotaria = tab !== 'vigencia';

  return (
    <div style={st.container}>
      <div style={st.frame}>
        <div style={st.frameHeader}>
          <button style={st.backBtn} onClick={onVolver}>← Dashboard</button>
          {onVerHipotecas && <button style={st.backBtn} onClick={onVerHipotecas}>🏦 Hipotecas</button>}
          {onVerReportes && <button style={st.backBtn} onClick={onVerReportes}>📊 Reportes</button>}
          {onVerHistorico && <button style={st.backBtn} onClick={onVerHistorico}>📜 Histórico</button>}
          <h2 style={st.title}>🔔 Notificaciones</h2>
        </div>
        <div style={st.tabs}>
          {TABS.map(t => (
            <button key={t.id} style={tabStyle(tab === t.id)} onClick={() => setTab(t.id)}>{t.label}</button>
          ))}
        </div>

        <div style={st.panel}>
          <div style={sh.toolbar}>
            <span style={sh.liveBadge}>🟢 En vivo · siempre hoy</span>
            <FiltroUsuarios etiqueta={false} ancho={260} />
          </div>

          {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

          <div style={sh.tableScroll}>
            <table style={sh.table}>
              <thead>
                <tr>
                  {mostrarTipoPill && <th style={sh.th}>Tipo</th>}
                  <th style={sh.th}>Cliente</th>
                  <th style={sh.th}>Banco</th>
                  <th style={sh.th}>Tipo de Crédito</th>
                  <th style={{ ...sh.th, ...sh.num }}>Monto Autorizado</th>
                  <th style={sh.th}>Fecha</th>
                  {mostrarNotaria && <th style={sh.th}>Notaría</th>}
                  <th style={{ ...sh.th, ...sh.num }}>Días</th>
                  <th style={sh.th}></th>
                </tr>
              </thead>
              <tbody>
                {cargando && <tr><td colSpan={9} style={sh.empty}>Cargando...</td></tr>}
                {!cargando && filas.length === 0 && (
                  <tr><td colSpan={9} style={sh.empty}>Sin notificaciones pendientes</td></tr>
                )}
                {!cargando && filas.map(f => {
                  const pill = PILL_TIPO[f.tipo];
                  const fecha = f.tipo === 'proximo_firmar' ? f.fecha_programada_firma : f.fecha_vigencia;
                  return (
                    <tr key={`${f.tipo}-${f.id}`} style={diasStyle(f.tipo, f.dias_restantes)}>
                      {mostrarTipoPill && (
                        <td style={sh.td}><span style={sh.pill(pill.bg, pill.color)}>{pill.label}</span></td>
                      )}
                      <td style={sh.td}>{f.nombre_cliente ? f.nombre_cliente.toUpperCase() : '(Sin nombre)'}</td>
                      <td style={sh.td}>{f.banco}</td>
                      <td style={sh.td}>{f.tipo_credito || 'Sin clasificar'}</td>
                      <td style={{ ...sh.td, ...sh.num }}>{money(f.monto_autorizado)}</td>
                      <td style={sh.td}>{fecha}</td>
                      {mostrarNotaria && <td style={sh.td}>{f.tipo === 'proximo_firmar' ? (f.notaria || '—') : '—'}</td>}
                      <td style={{ ...sh.td, ...sh.num, fontWeight: 'bold', color: diasColor(f.tipo, f.dias_restantes) }}>{f.dias_restantes}</td>
                      <td style={sh.td}>
                        {puedeMarcar(f)
                          ? <button style={sh.btnLeida} onClick={() => marcarLeida(f.id, f.tipo)}>✓ Marcar como leída</button>
                          : <span style={{ fontSize: 12, color: '#9ca3af' }}>👁 Solo lectura</span>}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeguimientoNotificacionesHome;
